/** Локализованные поля услуги (из презентации / fallback). */
export const serviceTitle = (s, lang) => {
  if (!s) return '';
  if (lang === 'mn' && s.titleMn) return s.titleMn;
  if (lang === 'en' && s.titleEn) return s.titleEn;
  if (s.titleRu) return s.titleRu;
  return s.title || '';
};

export const serviceShort = (s, lang) => {
  if (!s) return '';
  if (lang === 'mn' && s.shortDescriptionMn) return s.shortDescriptionMn;
  if (lang === 'en' && s.shortDescriptionEn) return s.shortDescriptionEn;
  if (s.shortDescriptionRu) return s.shortDescriptionRu;
  return s.shortDescription || '';
};

export const serviceFull = (s, lang) => {
  if (!s) return '';
  if (lang === 'mn' && s.fullDescriptionMn) return s.fullDescriptionMn;
  if (lang === 'en' && s.fullDescriptionEn) return s.fullDescriptionEn;
  if (s.fullDescriptionRu) return s.fullDescriptionRu;
  return s.fullDescription || '';
};

/** Наименование строки прайса (вид работ). */
export const priceRowName = (item, lang) => {
  if (!item) return '';
  if (lang === 'mn' && item.nameMn) return item.nameMn;
  if (lang === 'en' && item.nameEn) return item.nameEn;
  if (item.nameRu) return item.nameRu;
  return item.name || '';
};

/** Текст вместо суммы (например «по прайс-листу»). */
export const priceRowFreeText = (item, lang) => {
  if (!item) return '';
  if (lang === 'mn' && item.priceTextMn) return item.priceTextMn;
  if (lang === 'en' && item.priceTextEn) return item.priceTextEn;
  if (item.priceTextRu) return item.priceTextRu;
  return item.price || '';
};
